import styled from 'styled-components';

export const ExpertEligibleOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
  background-color: ${({ theme }) => theme.colors.white_2};
  z-index: 1;
  backdrop-filter: blur(4px);
`;

export const ExpertEligiblePanel = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.grey_1};
  padding: 24px 32px;

  max-width: 550px;

  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.beige_2};
  gap: ${({ theme }) => theme.appearance.spacing * 2.5}px;
`;
